import { render, staticRenderFns } from "./invoice-management.vue?vue&type=template&id=0b3404c6&"
import script from "./invoice-management.vue?vue&type=script&lang=js&"
export * from "./invoice-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports